import { render, staticRenderFns } from "./Side.vue?vue&type=template&id=00616b1d&scoped=true&"
import script from "./Side.vue?vue&type=script&lang=js&"
export * from "./Side.vue?vue&type=script&lang=js&"
import style0 from "./Side.vue?vue&type=style&index=0&id=00616b1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00616b1d",
  null
  
)

export default component.exports